var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-20"},[_c('a',{directives:[{name:"t",rawName:"v-t",value:(_vm.show ? 'generic.hideAdvanced' : 'generic.showAdvanced'),expression:"show ? 'generic.hideAdvanced' : 'generic.showAdvanced'"}],staticClass:"hand block",class:{'mb-10': _vm.show},on:{"click":_vm.toggle}}),_vm._v(" "),(_vm.show)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }